import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import XHR from "i18next-http-backend"
import LanguageDetector from "i18next-browser-languagedetector";
import TRANSLATIONS_ENGLISH from "locales/english/translation";

i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: TRANSLATIONS_ENGLISH
      }
    },
    detection: { order: ["path", "navigator"] },
    supportedLngs: ['en'],
    // lng: "sp", // if you're using a language detector, do not define the lng option
    fallbackLng: "en",

    interpolation: {
      escapeValue: false
    }
  });

  export default i18n